import { CONSTANTS } from '../../../utils'
import { isMobileOnly } from 'react-device-detect'

function CART_DEVICE_TYPE() {
	let device_type = CONSTANTS.DEVICE_TYPE.WEB
	if (isMobileOnly) {
		device_type = CONSTANTS.DEVICE_TYPE.MOBILE
	} else if (document.documentElement.clientWidth < 500) {
		device_type = CONSTANTS.DEVICE_TYPE.MOBILE
	}
	return device_type
}

const CART_HELPER = {
	CART_DEVICE_TYPE,
}
export default CART_HELPER
